import { GridRenderEditCellParams } from '@mui/x-data-grid';
import { TextField } from '@mui/material';
import { IAdults } from 'app/models/Placement/PlacementMods';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectEditPreferenceAdultRows,
  selectExpandedModsDialog,
  selectPreferenceAdultRelationshipError,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { getDisplayValue } from '../utils';
import { findIndex, findRow } from './AdultNameCell';

interface GridCellProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const AdultRelationshipCell = (cellParams: GridRenderEditCellParams) => {
  return (
    <>
      <AdultRelationship cellParams={cellParams} />
    </>
  );
};

const AdultRelationship = React.memo(function AdultRelationship(cellParams: GridCellProps) {
  const { control } = useFormContext();
  const dispatch = useDispatch();

  const editPreferenceAdultRowsRequests = useSelector(selectEditPreferenceAdultRows);
  const preferenceAdultRelationshipError = useSelector(selectPreferenceAdultRelationshipError);
  const isExpanded = useSelector(selectExpandedModsDialog);

  const RowId = cellParams?.cellParams?.id;
  const rowData = getDisplayValue(RowId, editPreferenceAdultRowsRequests);
  const relationship = rowData?.relationship;
  const [adultRelationship, setAdultRelationship] = useState(relationship === '--' ? null : relationship);

  const setRelationshipForAdultGridEdit = data => {
    let newRows = editPreferenceAdultRowsRequests.slice(0);
    let adultGridEditRow = findRow(editPreferenceAdultRowsRequests, RowId);

    let updatedRelationship = {} as IAdults;
    updatedRelationship = {
      ...adultGridEditRow,
      relationship: data ? data.trim() : '',
    };
    let editNameIndex = findIndex(editPreferenceAdultRowsRequests, RowId);
    newRows[editNameIndex] = updatedRelationship;
    dispatch(placementModsAction.setEditAdultRows(newRows));
  };
  useEffect(() => {
    if (cellParams?.cellParams?.error !== null && cellParams?.cellParams?.error !== undefined) {
      const val = preferenceAdultRelationshipError?.filter(el => el.id === cellParams?.cellParams?.id);

      if (val?.length === 0) {
        const arr = preferenceAdultRelationshipError?.length > 0 ? preferenceAdultRelationshipError.slice(0) : [];
        const valueObj = { relationship: cellParams?.cellParams?.error, id: cellParams?.cellParams?.id };

        arr.push(valueObj);

        dispatch(placementModsAction.setPreferenceAdultRelationshipError(arr));
      } else {
        const arr = preferenceAdultRelationshipError?.slice(0);
        let currentObj = arr.find(v => v.id === cellParams?.cellParams?.id);

        let updatedObj = { ...currentObj, relationship: cellParams?.cellParams?.error };

        let editIndex = arr.findIndex(v => v.id === cellParams?.cellParams?.id);
        arr[editIndex] = updatedObj;

        dispatch(placementModsAction.setPreferenceAdultRelationshipError(arr));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cellParams?.cellParams?.error]);

  return (
    <>
      <Controller
        name={`adultGrid${RowId}.relationship`}
        control={control}
        render={({ field: { onChange,onBlur, value, ...rest } }) => (
          <TextField
            required={true}
            variant="outlined"
            size={'small'}
            sx={{
              width: isExpanded ? '852px' : '274px',
            }}
            value={adultRelationship}
            inputProps={{ maxLength: 255 }}
            onBlur={e => {
              setRelationshipForAdultGridEdit(e.target.value);
              onChange(e.target.value);
            }}
            onChange={e => {
              if (e.target.value) {
                setAdultRelationship(e.target.value);
                onChange(e.target.value);
              } else {
                setAdultRelationship('');
              }
            }}
            {...rest}
          />
        )}
      />
    </>
  );
});
